//  material-ui imports
import { Button, CircularProgress } from '@mui/material';

// ==============================|| FILEMNGR DIALOG NEW FOLDER ||============================== //

/**
 * Renders the actions for the file manager dialog using MUI Buttons.
 * @author Marcos L. A. Soto <marcosleonildo@gmail.com>
 * @param {Array<Object>} buttons - An array of objects representing the buttons.
 * @param {string} buttons[].text - The text to display on the button.
 * @param {function} buttons[].onClick - The function to call when the button is clicked.
 * @param {string} [buttons[].variant='text'] - The variant of the button (e.g., 'text', 'contained', 'outlined').
 * @param {string} [buttons[].color='primary'] - The color of the button (e.g., 'primary', 'secondary', 'error').
 * @param {boolean} [buttons[].disabled=false] - Whether the button is disabled.
 * @returns {Array<ReactNode>} An array of React nodes representing the buttons.
 */
const renderFileMngrDialogActions = (buttons = []) =>
    buttons.map((btn) => (
        <Button
            key={btn.text}
            onClick={btn.onClick}
            variant={btn?.variant ?? 'text'}
            color={btn?.color ?? 'primary'}
            disabled={btn?.disabled ?? false}
            // autoFocus
        >
            {!btn.isLoading && btn.text}
            {btn.isLoading && <CircularProgress size={24} />}
        </Button>
    ));

export default renderFileMngrDialogActions;
